import { render, staticRenderFns } from "./hazardManagement.vue?vue&type=template&id=06eb0ad3&scoped=true&"
import script from "./hazardManagement.vue?vue&type=script&lang=ts&"
export * from "./hazardManagement.vue?vue&type=script&lang=ts&"
import style0 from "./hazardManagement.vue?vue&type=style&index=0&id=06eb0ad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb0ad3",
  null
  
)

export default component.exports